import React, { useContext, useEffect, useReducer, useState } from 'react';
import { AuthContext } from '../../contexts/AuthContext';
import { Link } from 'react-router-dom';
import Util from '../../Util';
import { SignalRContext } from '../../contexts/SignalRContext';
import alertify from "alertifyjs";

var peerConnectionConfig = { "iceServers": [{ "url": "stun:stun.l.google.com:19302" }] };

const SET_STREAM = "SET_STREAM";
const SET_CONNECTION = "SET_CONNECTION";
const SET_WOWZA_STREAM_NAME = "SET_WOWZA_STREAM_NAME";

const initialValue = {
	WOWZA_STREAM_NAME: null, 
	connections: {},
	localStream: null
}

const reducer = (state, action) => {
	switch(action.type)
	{
		case SET_STREAM:
			return {...state, localStream: action.localStream };
	}
}

const VoiceCall = (props) => {
	const receiver = JSON.parse(props.location.state.receiver);

	const { userState } = useContext(AuthContext);
	const { signalRConnection, join, getCallerStream, setCallerStream } = useContext(SignalRContext);
	const [caller, setCaller] = useState(userState.user);
	const [state, dispature] = useReducer(reducer, initialValue);

	var webrtcConstraints = { audio: true, video: false };
	var WOWZA_STREAM_NAME = null, connections = {}; 
	let tStream = null;

	const errorHandler = (error) => {
		console.log(error);
	};

	const callbackUserMediaSuccess = (stream) => {
		console.log("WebRTC: got media stream " + stream);
//		localStream = stream;
	//	setLocalStream(stream);
		const audioTracks = stream.getAudioTracks();
		if (audioTracks.length > 0) {
			console.log(`Using Audio device: ${audioTracks[0].label}`);
		}
	};

	signalRConnection.on('updateUserList', (userList) => {
		console.log('SignalR: called updateUserList' + JSON.stringify(userList));
		var isCallerinList = false;
		var isReceiverinList = false;
		userList.forEach(item => {
			if(item.userName == caller.userName)
			{
				isCallerinList = true;
			}
		});

		userList.forEach(item => {
			if(item.userName == receiver.emailAddress)
			{
				isReceiverinList = true;
			}
		});

		if(!isCallerinList)
		{
			join(caller.userName);
		}

		if(!isReceiverinList)
		{
			alertify.error(receiver.emailAddress + " user is not loggedin")
		}

	});
	

	signalRConnection.on('callAccepted', (acceptingUser) => {
		console.log('SignalR: call accepted from: ' + JSON.stringify(acceptingUser) + '.  Initiating WebRTC call and offering my stream up...');
		
		navigator.getUserMedia(webrtcConstraints, 
			(stream) => {
				
				console.log("WebRTC: got media stream " + stream);
				setCallerStream(stream);
				dispature({type: SET_STREAM, localStream: stream});

				tStream = stream;
				console.log(tStream);

				const audioTracks = stream.getAudioTracks();
				if (audioTracks.length > 0) {
					console.log(`Using Audio device: ${audioTracks[0].label}`);
				}
			}, 
			errorHandler
		);

		setTimeout(() => initiateOffer(acceptingUser.connectionId, tStream), 3000);

		// Callee accepted our call, let's send them an offer with our video stream
		 // Will use driver email in production
		// Set UI into call mode
		//$('body').attr('data-mode', 'incall');
		//$("#callstatus").text('In Call');
	});


	const attachMediaStream = (e) => {
		//console.log(e);
		console.log("OnPage: called attachMediaStream");
		var partnerAudio = document.querySelector('.audio.partner');
		if (partnerAudio.srcObject !== e.stream) {
			partnerAudio.srcObject = e.stream;
			console.log("OnPage: Attached remote stream");
		}
	};
  
	const getConnection = (partnerClientId) => {
		console.log("WebRTC: called getConnection");
		if (connections[partnerClientId]) {
			console.log("WebRTC: connections partner client exist");
			return connections[partnerClientId];
		}
		else {
			console.log("WebRTC: initialize new connection");
			return initializeConnection(partnerClientId)
		}
	}

	const callbackRemoveStream = (connection, evt) => {
		console.log('WebRTC: removing remote stream from partner window');
		// Clear out the partner window
		var otherAudio = document.querySelector('.audio.partner');
		otherAudio.src = '';
	}
	
	const callbackAddStream = (connection, evt) => {
		console.log('WebRTC: called callbackAddStream');
	
		// Bind the remote stream to the partner window
		//var otherVideo = document.querySelector('.video.partner');
		//attachMediaStream(otherVideo, evt.stream); // from adapter.js
		attachMediaStream(evt);
	}
	
	const callbackNegotiationNeeded = (connection, evt) => {
		console.log("WebRTC: Negotiation needed...");
		//console.log("Event: ", evt);
	}
	
	const callbackIceCandidate = (evt, connection, partnerClientId) => {
		console.log("WebRTC: Ice Candidate callback");
		//console.log("evt.candidate: ", evt.candidate);
		if (evt.candidate) {// Found a new candidate
			console.log('WebRTC: new ICE candidate');
			//console.log("evt.candidate: ", evt.candidate);
			sendHubSignal(JSON.stringify({ "candidate": evt.candidate }), partnerClientId);
		} else {
			// Null candidate means we are done collecting candidates.
			console.log('WebRTC: ICE candidate gathering complete');
			sendHubSignal(JSON.stringify({ "candidate": null }), partnerClientId);
		}
	}

	const initializeConnection = (partnerClientId) => {
		console.log('WebRTC: Initializing connection...');
		//console.log("Received Param for connection: ", partnerClientId);
	
		var connection = new RTCPeerConnection(peerConnectionConfig);
	
		//connection.iceConnectionState = evt => console.log("WebRTC: iceConnectionState", evt); //not triggering on edge
		//connection.iceGatheringState = evt => console.log("WebRTC: iceGatheringState", evt); //not triggering on edge
		//connection.ondatachannel = evt => console.log("WebRTC: ondatachannel", evt); //not triggering on edge
		//connection.oniceconnectionstatechange = evt => console.log("WebRTC: oniceconnectionstatechange", evt); //triggering on state change 
		//connection.onicegatheringstatechange = evt => console.log("WebRTC: onicegatheringstatechange", evt); //triggering on state change 
		//connection.onsignalingstatechange = evt => console.log("WebRTC: onsignalingstatechange", evt); //triggering on state change 
		connection.onicecandidate = evt => callbackIceCandidate(evt, connection, partnerClientId); // ICE Candidate Callback
		//connection.onnegotiationneeded = evt => callbackNegotiationNeeded(connection, evt); // Negotiation Needed Callback
		connection.onaddstream = evt => callbackAddStream(connection, evt); // Add stream handler callback
		//connection.ontrack = evt => console.log("WebRTC: ontrack", evt);
		
		connection.onremovestream = evt => callbackRemoveStream(connection, evt); // Remove stream handler callback
	
		connections[partnerClientId] = connection; // Store away the connection based on username
		//console.log(connection);
		return connection;
	}
	
	

	const initiateOffer = (partnerClientId, stream) => {


		console.log('WebRTC: called initiateoffer: ');
		var connection = getConnection(partnerClientId); // // get a connection for the given partner
		console.log("Connection: ", connection);
		console.log('initiate Offer stream: ', stream);
		console.log("offer connection: ", connection);
		connection.addStream(stream);// add our audio/video stream
		console.log("WebRTC: Added local stream");
	
		connection.createOffer().then(offer => {
			console.log('WebRTC: created Offer: ');
			console.log('WebRTC: Description after offer: ', offer);
			connection.setLocalDescription(offer).then(() => {
				console.log('WebRTC: set Local Description: ');
				console.log('connection before sending offer ', connection);
				setTimeout(() => {
					sendHubSignal(JSON.stringify({ "sdp": connection.localDescription }), partnerClientId);
				}, 1000);
			}).catch(err => console.error('WebRTC: Error while setting local description', err));
		}).catch(err => console.error('WebRTC: Error while creating offer', err));
	
		//connection.createOffer((desc) => { // send an offer for a connection
		//    console.log('WebRTC: created Offer: ');
		//    console.log('WebRTC: Description after offer: ', JSON.stringify(desc));
		//    connection.setLocalDescription(desc, () => {
		//        console.log('WebRTC: Description after setting locally: ', JSON.stringify(desc));
		//        console.log('WebRTC: set Local Description: ');
		//        console.log('connection.localDescription: ', JSON.stringify(connection.localDescription));
		//        sendHubSignal(JSON.stringify({ "sdp": connection.localDescription }), partnerClientId);
		//    });
		//}, errorHandler);
	}

	const initializeUserMedia = () => {
		console.log('WebRTC: InitializeUserMedia: ');
		navigator.getUserMedia(webrtcConstraints, 
			(stream) => {
				
				console.log("WebRTC: got media stream " + stream);
				setCallerStream(stream);
				dispature({type: SET_STREAM, localStream: stream});

				tStream = stream;
				console.log(tStream);

				const audioTracks = stream.getAudioTracks();
				if (audioTracks.length > 0) {
					console.log(`Using Audio device: ${audioTracks[0].label}`);
				}
			}, 
			errorHandler
		);
		
		signalRConnection.invoke("SendUserListUpdate").catch((err) => {
            console.log(err);
            //viewModel.Loading(false);
        });
	};

	const sendHubSignal = (candidate, partnerClientId) => {
		console.log('candidate', candidate);
		console.log('SignalR: called sendhubsignal ');
		signalRConnection.invoke('sendSignal', candidate, partnerClientId).catch(errorHandler);
	};

	const initializeCall = () => {
		console.log(receiver.emailAddress);

		//Make sure we are not making call ourself
		if (receiver.emailAddress != caller.userName) {
			// Initiate a call
			signalRConnection.invoke('callUser', { "userName": receiver.emailAddress }, { "userName": caller.userName });

			// UI in calling mode
		//	$("#callstatus").text('Calling...');
		} else {
			alertify.error("Ah, nope.  Can't call yourself.");
		}
	}
	
   	useEffect(() => {
		initializeUserMedia();

		if(signalRConnection.connectionState == 0)
		{
			signalRConnection.start().then(() => { 
				initializeCall();
				// Make sure we are in a state where we can make a call
			//	if ($('body').attr("data-mode") !== "idle") {
			//		console.log('Sorry, you are already in a call.  Conferencing is not yet implemented.');
			//		return;
			//	}
				signalRConnection.invoke("SendUserListUpdate").catch((err) => {
					console.log(err);
					//viewModel.Loading(false);
				});
			}).catch(err => 
				console.log(err)
			);
		}
		else {
			initializeCall();
		}
    }, [signalRConnection]);

    return (  
        <div className="content">
				<div className="container">
					<div className="call-wrapper">
						<div className="call-main-row">
							<div className="call-main-wrapper">
								<div className="call-view">
									<div className="call-window">
										<div className="fixed-header">
											<div className="navbar">
												<div className="user-details mr-auto">
													<div className="float-left user-img">
                                                        <Link className="avatar avatar-sm mr-2" 
                                                                to={"patient-profile.html"} target="_blank" 
                                                                title="Charlene Reed">
                                                            <img src={Util.loadImage("")} 
                                                                alt="User Image" 
                                                                className="rounded-circle" />
															<span className="status online"></span>
														</Link>
													</div>
													<div className="user-info float-left">
														<a href="patient-profile.html"><span>Charlene Reed</span></a>
                                                        <span className="last-seen">Online</span>
													</div>
												</div>
												<ul className="nav float-right custom-menu">
													<li className="nav-item dropdown dropdown-action">
														<a href="#" className="nav-link dropdown-toggle" data-toggle="dropdown" aria-expanded="false"><i className="fa fa-cog"></i></a>
														<div className="dropdown-menu dropdown-menu-right">
															<a href="javascript:void(0)" className="dropdown-item">Settings</a>
														</div>
													</li>
												</ul>
											</div>
										</div>
										<div className="call-contents">
											<div className="call-content-wrap">
												<div className="voice-call-avatar">
													<img src="assets/img/doctors/doctor-thumb-02.jpg" alt="User Image" className="call-avatar" />
													<span className="username">Dr. Darren Elder</span>
													<audio className="audio partner" autoplay="" controls="" muted ></audio>
												</div>
											</div>
										</div>
										<div className="call-footer">
											<div className="call-icons">
												<ul className="call-items">
													<li className="call-item">
														<a href="#" title="Enable Video" data-placement="top" data-toggle="tooltip">
															<i className="fas fa-video camera"></i>
														</a>
													</li>
													<li className="call-item">
														<a href="#" title="Mute" data-placement="top" data-toggle="tooltip">
															<i className="fa fa-microphone microphone"></i>
														</a>
													</li>
													<li className="call-item">
														<a href="#" title="Add User" data-placement="top" data-toggle="tooltip">
															<i className="fa fa-user-plus"></i>
														</a>
													</li>
												</ul>
												<div className="end-call">
													<a href="javascript:void(0);">
														<i className="material-icons">call_end</i>
													</a>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
    		</div>		
    );
}
 
export default VoiceCall;